<template>
  <div> 
    <div class='glitchHolder'>
      <div v-if="glitches" id="glitchOverlay" :style="{top:glitchTop+'px'}">
        <div v-for="g in glitches" class='glitchOver' :style="{marginBottom:g.pad+'px',width:g.width+'%'}">
        <div v-for="gc in g.child" class='glitchChild' :style="{backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'}"></div>
        </div>
      </div>
    </div>
    <v-container ma-0 pt-0  >
      <v-layout >
        <v-flex xs12 class="text-xs-center">
          <v-progress-circular indeterminate :size="50" 
            color="grey" 
            :width="7" 
            v-if="loading"></v-progress-circular>
        </v-flex>
      </v-layout>    
      <v-layout>
        <v-flex xs12 offset-xs0 sm10 offset-sm2 pa-2 >
       
          <h2>Contact</h2>
         <p>
          For more information about submitting content go to the <v-btn :to="'/participate'">Participate</v-btn> page.
         <!-- For more information go to our 
<a href="https://www.hobartcity.com.au/Community/Arts-and-culture/Public-art/Current-opportunities?BestBetMatch=opportunities|d13b95b2-5146-4b00-9e3e-a80c73739a64|4f05f368-ecaa-4a93-b749-7ad6c4867c1f|en-AU">expression of interest</a> page.</p> -->
          </p>
          <p>For all queries contact the Public Art Team<br>
          <a href="mailto:publicart@hobartcity.com.au">publicart@hobartcity.com.au</a> 
          or (03) 6238 2565.</p>
          
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
 export default {
   
   data () {
     return {
       glitches:null,
       glitchCount:20,
       glitchTop:0
     }
   },
   mounted(){
     this.glitches=[]
     let childA=[]  
      for(var i=0;i<8;i++){
        childA=[]
        for(var p=0;p<2;p++){
          childA.push(Math.floor(Math.random()*100));   
        }
        this.glitches.push({colour:'#00000044',height:30,pad:3,width:Math.random()*50+50,child:childA})
      }
      setTimeout(this.glitch,100);
   },
   computed: {
     loading () {
       return this.$store.getters.loading
     },
    
    },
   methods: {
     glitch(){

        this.glitchCount++
        if(this.glitchCount>50){
            this.glitchCount=Math.random()*20-10
            this.glitchTop=Math.random()*400+100;
        }
       if(this.glitchCount>10){
         this.glitchCount+=Math.random()*40
          setTimeout(this.glitch,Math.random()*100+100);
          
          return
         
       }
        
       
        for(var g in this.glitches){
          if(Math.random()*10>7){
            this.glitches[g].height=Math.random()*20+5;
            for(var gc in this.glitches[g].child){
                this.glitches[g].child[gc]=Math.floor(Math.random()*160+20);
            }
             if(Math.random()*10>5){
               this.glitches[g].height=0;
             }
          }
          this.glitches[g].pad=Math.floor(Math.random()*5+5)
          this.glitches[g].width=Math.floor(Math.random()*160+20) 
        }
        if(Math.random()*10>5){
         // this.glitchTop=Math.random()*400+100;
        }
        setTimeout(this.glitch,100);
     }
     
   }
 }
</script>

<style scoped>
  .glitchHolder{
    position: absolute;
    top: 0px;
    height: 100%;
    width: 100%;
    min-height: 100px;
    overflow: hidden;
    pointer-events: none;
  }
  #glitchOverlay{
  position:absolute;
  left:-100px;
  top:0px;
}
.glitchOver{
  
  z-index:3;
  position:relative;
  min-height:30px;
  pointer-events:none;
  opacity:0.3;
  width:400px;
  
}
.glitchChild{
  width:40px;
  display:inline-block;
  background-color:#00f;
}

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue